import React from "react";
import PropTypes from "prop-types";
import { TextField, InputAdornment } from "@mui/material";

const TextInput = ({
  id,
  size = "small",
  variant,
  required,
  placeholder,
  fullWidth,
  multiline,
  disabled,
  readonly,
  InputStartIcon,
  InputEndIcon,
  inputError,
  helperText,
  rows,
  type,
  name,
  value,
  onChange,
  onKeyDown,
  styleProps,
  textLength
}) => {
  return (
    <TextField
      id={id}
      size={size || "small"}
      variant={variant || "outlined"}
      required={required}
      placeholder={placeholder}
      fullWidth={fullWidth}
      multiline={multiline}
      disabled={disabled}
      error={inputError}
      helperText={helperText}
      rows={rows}
      type={type || "text"}
      name={name}
      value={value}
      sx={styleProps}
      onChange={onChange}
      onKeyDown={onKeyDown}
      inputProps={{
        maxLength: textLength
      }}
      InputProps={{
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment position="end">{InputEndIcon}</InputAdornment>
        ),
      }}
    />
  );
};

TextInput.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  InputStartIcon: PropTypes.element,
  type: PropTypes.string,
  InputEndIcon: PropTypes.element,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  inputError: PropTypes.bool,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  required: PropTypes.bool,
  styleProps: PropTypes.object,
};

TextInput.defaultProps = {
  type: "text",
  fullWidth: true,
  multiline: false,
  disabled: false,
  readonly: false,
  inputError: false,
  helperText: "",
  variant: "outlined",
  size: "small",
  required: false,
  styleProps: {},
};

export default TextInput;
